import { format, subDays } from 'date-fns';
import type { ILeave, LeaveStatus } from '../types/leave';

const toUtcDayKey = (d: string | Date) => format(new Date(d), 'yyyy-MM-dd');

export const userIdFromLeaveUser = (user: ILeave['user']): string | null => {
  if (user && typeof user === 'object' && '_id' in user && (user as { _id?: string })._id) {
    return String((user as { _id: string })._id);
  }
  if (typeof user === 'string') return user;
  return null;
};

export const leaveOverlapsViewRange = (
  leave: Pick<ILeave, 'startDate' | 'endDate'>,
  viewStart: string | Date,
  viewEnd: string | Date,
): boolean => {
  const ls = toUtcDayKey(leave.startDate);
  // endDate = date de retour effective ; le dernier jour de congé est la veille
  const lastLeaveDay = toUtcDayKey(subDays(new Date(leave.endDate), 1));
  const vs = toUtcDayKey(viewStart);
  const ve = toUtcDayKey(viewEnd);
  if (lastLeaveDay < ls) {
    return false;
  }
  return ls <= ve && lastLeaveDay >= vs;
};

/** Picto admin planning : vert si congé validé, jaune si en attente / à planifier */
export const leavePictoKindFromStatus = (status: LeaveStatus): 'approved' | 'pending' | null => {
  if (status === 'approved') return 'approved';
  if (status === 'pending' || status === 'to_plan') return 'pending';
  return null;
};
